import * as React from 'react';
export const LinkingContext = /*#__PURE__*/React.createContext({
  options: undefined
});
LinkingContext.displayName = 'LinkingContext';
//# sourceMappingURL=LinkingContext.js.map